import React from 'react'
import {InvoiceData, List} from '../types'
import BootstrapPagination from 'react-bootstrap/Pagination'
import {getPageFromUrl} from '../services/getPageFromUrl'

interface Props {
	data: List<InvoiceData>
	setPage: (page: number) => void
}

const Pagination: React.FC<Props> = ({ data, setPage }) => {
	const links = data.meta.links
	const activeLinkIndex = links.findIndex(link => link.active)
	const activePage = activeLinkIndex !== -1 ? getPageFromUrl(links[activeLinkIndex].url ?? '1') : 1

	const visibleLinks = links.filter(link => link.label !== '&laquo; Previous' && link.label !== 'Next &raquo;')
	const totalPages = visibleLinks.length

	const getEllipsis = (key: number) => (
		<BootstrapPagination.Ellipsis key={key} />
	)

	const getPaginationItems = () => {
		const items = []

		for (let i = 1; i <= totalPages; i++) {
			if (i === 1 || i === totalPages || (i >= activePage! - 2 && i <= activePage! + 2)) {
				items.push(
					<BootstrapPagination.Item
						key={i}
						active={i === activePage}
						onClick={() => setPage(i)}
					>
						{i}
					</BootstrapPagination.Item>
				)
			} else if (i === activePage! - 3 || i === activePage! + 3) {
				items.push(getEllipsis(i))
			}
		}
		return items
	}

	return (
		<div className='w-100 d-flex justify-content-center'>
			{data.meta.last_page > 1 && <BootstrapPagination size='sm'>
				<BootstrapPagination.Prev disabled={activePage === 1} onClick={() => setPage(activePage! - 1)}/>
				{getPaginationItems()}
				<BootstrapPagination.Next disabled={activePage === totalPages} onClick={() => setPage(activePage! + 1)}/>
			</BootstrapPagination>}
		</div>
	)
}

export default Pagination
